import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArrByPropValue'
})
export class FilterArrByPropValuePipe implements PipeTransform {

  transform(value: string, arr: any[], propName: string): any[] {
    if (!value?.length) {
      return arr;
    }

    return arr.filter(item =>
      item[propName].toLowerCase().includes(value.toLowerCase())
    );
  }

}
